import { capitalize } from 'lodash';

import { formatPhoneNumber } from 'lib/helpers/utility';

const columns = [
  { field: 'id', headerName: 'ID', maxWidth: 100 },
  {
    field: 'f_name',
    headerName: 'First Name',
    minWidth: 150,
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'l_name',
    headerName: 'Last Name',
    minWidth: 150,
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'phone',
    headerName: 'Phone',
    valueFormatter: ({ value }) => formatPhoneNumber(value)
  },
  { field: 'email', headerName: 'Email', minWidth: 200 },
  {
    field: 'status',
    headerName: 'Status',
    valueFormatter: ({ value }) => capitalize(value)
  }
];

export default columns;
